import { action } from 'typesafe-actions';
import { MembersActionTypes, Params } from 'types';

export const fetchMemberStart = (request?: Params) =>
  action(MembersActionTypes.FETCH_MEMBER_START, request);

export const fetchMemberSuccess = (members: any) =>
  action(MembersActionTypes.FETCH_MEMBER_SUCCESS, members);

export const fetchMemberFailure = (error: any) =>
  action(MembersActionTypes.FETCH_MEMBER_FAILURE, error);

export const fetchMemberSearchStart = (request?: Params) =>
  action(MembersActionTypes.FETCH_MEMBER_SEARCH_START, request);

export const fetchMemberSearchFailure = (error: any) =>
  action(MembersActionTypes.FETCH_MEMBER_SEARCH_FAILURE, error);

export const fetchOrgListByBoundary = (request?: any) =>
  action(MembersActionTypes.SET_ORG_LIST_BY_BOUNDARY_START, request);

export const fetchOrgListByBoundarySuccess = (items: any) =>
  action(MembersActionTypes.SET_ORG_LIST_BY_BOUNDARY_SUCCESS, items);

export const removeErrors = () => action(MembersActionTypes.REMOVE_ERROR);

export const clearSelectedMember = () =>
  action(MembersActionTypes.CLEAR_SELECTED_MEMBER);
